import React from 'react';
import { Row, Col } from 'react-bootstrap';

import NumberOfStopsFilter from './numberOfStopsFilter/NumberOfStopsFilter';
import ClearAllFilters from './clearAllFilters/ClearAllFilters';
import BaggageFilter from './baggageFilter/BaggageFilter';
import AirCompaniesFilter from './airCompaniesFilter/AirCompaniesFilter';
import { EXCLUDED_OPERATING_CARRIER } from '../../../const/Company';

import I18n from 'i18n-react';

import './Filters.css';

const AZUL_COMPANY_CODE = 'AD';

class Filters extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isTouched: false,
      auxFilter: [],
      originFilter: {
        baggageList: [],
        stopoverList: [],
        companiesList: []
      },
      filteredList: {
        baggageList: [],
        stopoverList: [],
        companiesList: []
      }
    };
    this.childKey = 0;
  }

  componentDidMount() {
    let origin = this.state.originFilter;
    origin.baggageList = this.mountBaggageFilter(this.props.auxFlights);
    origin.stopoverList = this.mountStopOverFilter(this.props.auxFlights);
    origin.companiesList = this.mountCompaniesList(this.props.auxFlights);

    this.setState({ originFilter: origin });
  }

  mountBaggageFilter = function(flights) {
    let baggageList = [];
    let withBaggage = false;
    let withOutBaggage = false;
    let count = 0;
    flights.forEach(flight => {
      if (flight.baggage != null) {
        if (flight.baggage[0].quantity > 0 && withBaggage === false) {
          baggageList.push({
            id: count++,
            name: 'Com bagagem'
          });
          withBaggage = true;
        }
        if (
          (flight.baggage[0].quantity === 0 || flight.baggage[0].quantity === null) &&
          withOutBaggage === false
        ) {
          baggageList.push({
            id: count++,
            name: 'Sem bagagem'
          });
          withOutBaggage = true;
        }
      }
    });

    return baggageList;
  };

  mountStopOverFilter = function(flights) {
    let stopOverQuantities = [];
    let stopOverList = [];

    flights.forEach(flight => {
      stopOverQuantities.push(flight.flightGroup.length);
    });

    let count = 0;
    if (stopOverQuantities.includes(1)) {
      stopOverList.push({
        id: count++,
        name: 'Voo direto'
      });
    }

    if (stopOverQuantities.includes(2)) {
      stopOverList.push({
        id: count++,
        name: 'Uma parada'
      });
    }

    if (stopOverQuantities.includes(3)) {
      stopOverList.push({
        id: count++,
        name: 'Duas paradas ou mais'
      });
    }

    return stopOverList;
  };

  componentDidUpdate() {
    if (this.props.auxFlights !== undefined && this.props.auxFlights.length > 0) {
      let companiesList = this.mountCompaniesList(this.props.auxFlights);
      if (this.state.originFilter.companiesList.length !== companiesList.length) {
        let companies = this.state.originFilter;
        companies.baggageList = this.mountBaggageFilter(this.props.auxFlights);
        companies.stopoverList = this.mountStopOverFilter(this.props.auxFlights);
        companies.companiesList = companiesList;
        this.setState({ originFilter: companies });
      }
    }
  }

  mountCompaniesList(flights) {
    let flightsOption = [];
    let companyName;
    flights.forEach(flight => {
      companyName = flight.flightGroup
        .filter(
          e =>
            e.marketingCarrier !== AZUL_COMPANY_CODE &&
            e.operatingCarrier !== EXCLUDED_OPERATING_CARRIER
        )
        .map(e => e.marketingCarrier)
        .pop();
      if (companyName !== undefined) {
        flightsOption.push({
          id: flight.id,
          name: companyName
        });
      } else {
        flightsOption.push({
          id: flight.id,
          name: AZUL_COMPANY_CODE
        });
      }
    });

    let marketingCarriersList = flightsOption
      .map(item => item.name)
      .filter((value, index, self) => self.indexOf(value) === index);

    let newList = [];
    marketingCarriersList.forEach(flight => {
      if (flight !== undefined)
        newList.push({ id: flight, name: I18n.translate('company.' + flight) });
    });

    return newList;
  }

  render() {
    const { originFilter } = this.state;
    return (
      <Row className="box-filters">
        <Col xs={8} className="col-allFilters">
          <Row className="row-filters">
            <Col xs={3} className="col-filter">
              <BaggageFilter
                key={this.childKey}
                originFilter={originFilter}
                filteredList={this.props.filteredList}
                updateFilters={this.props.updateFilters}
                flightType={this.props.flightType}
              />
            </Col>
            <Col xs={3} className="col-filter">
              <NumberOfStopsFilter
                key={this.childKey}
                originFilter={originFilter}
                filteredList={this.props.filteredList}
                updateFilters={this.props.updateFilters}
                flightType={this.props.flightType}
              />
            </Col>
            <Col xs={3} className="col-filter">
              <AirCompaniesFilter
                key={this.childKey}
                originFilter={originFilter}
                filteredList={this.props.filteredList}
                updateFilters={this.props.updateFilters}
                ref="AirCompaniesDropdown"
                flightType={this.props.flightType}
              />
            </Col>
            <Col xs={3} className="col-filter">
              <ClearAllFilters
                clearFilters={() => {
                  this.props.clearFilters(this.props.flightType);
                  ++this.childKey;
                }}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }
}

export default Filters;



// WEBPACK FOOTER //
// ./src/components/flightSelection/filters/Filters.jsx